import { useSelector } from 'react-redux';
import { ZEROEYES as ZEROEYES_CAPABILITY } from '@rsos/capstone/src/constants/capabilities';
import { ZEROEYES as ZEROEYES_PERMISSION } from '@rsos/capstone/src/constants/permissionNames';
import { SinatraState, selectUserPermissionsByApp } from '@rsos/sinatra';
import { PsapState } from '../capstone/psapInfo/psapInfoSlice';
import { ADRDataState } from './adrDataSlice';

const WEAPON_DETECTED_TYPE = 'data.weapon_detection.zeroeyes.weapon_detection';

export const isZeroEyesEnabled = (state: {
  sinatra: SinatraState;
  psaps: PsapState;
}) => {
  const user = state.sinatra.user;
  const currentPSAP = state.psaps.currentPSAP;
  const permissions =
    user.profile && selectUserPermissionsByApp(user, 'capstone');

  return Boolean(
    currentPSAP?.activeCapabilities?.[ZEROEYES_CAPABILITY] &&
      permissions?.includes(ZEROEYES_PERMISSION),
  );
};

export const useHasZeroEyesEvent = (callerId: string) => {
  return useSelector((state: { adrData: ADRDataState }) => {
    const callData = state.adrData.data[`tel://${callerId}`];

    if (!callData) {
      return false;
    }

    for (const data of callData.data) {
      if (data?.type === WEAPON_DETECTED_TYPE) {
        return true;
      }
    }

    return false;
  });
};
